import { useState, useEffect, forwardRef } from "react";
import { useSelector } from 'react-redux';
import { fetchApi } from '../../services/apiService'
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const VendorAutocomplete = forwardRef((props, ref) => {
    const { allOption = false, selectedValues = [], prevId, nextId, searchVendorCategories, onDataLoadCallback = null, countryId = undefined, isFormikFormField = false, showFormError = false, showGstNo = false, disabled = false, isCompulsory = false, onlyActiveVendors = false, ...rest } = props;
    // console.log('selectedValues-vendor',selectedValues);

    let vendorNameOptions = [];

    if (allOption) {
        vendorNameOptions.push({ vendorName: 'All Vendors', vendorId: 0 });
    }
    let initialProps = {
        ...rest,
        labelKey: !showGstNo ? 'vendorName' : 'vendorWithGstNo',
        primaryKey: 'vendorId',
        options: vendorNameOptions,
        isObject: true,
        disabled,
        isFormikFormField,
        showFormError,
        isCompulsory,
        dataLoaded: false,
        prevId,
        nextId
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getVendorOptions = async () => {
            let getVendorParams = { countryId };
            setDefaultProps({...defaultProps, dataLoaded: true});
            if (props.searchVendorCategories !== "") {
                getVendorParams = { ...getVendorParams, searchVendorCategories: searchVendorCategories };
            }
            if (onlyActiveVendors) {
                getVendorParams = { ...getVendorParams, status: 1 };
            }
            const response = await fetchApi('masters/getVendors', getVendorParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                if (onDataLoadCallback) {
                    onDataLoadCallback(response.data);
                }
                let newOptions = [];
                if (allOption) {
                    newOptions.push({ vendorName: 'All Vendors', vendorId: 0 });
                }
                if (response.data.vendors.length > 0) {
                    newOptions = newOptions.concat(response.data.vendors);
                }
                if (newOptions.length > 0) {
                    newOptions = newOptions.map((s) => {
                        if (s.gstTinNo !== null) {
                            return { ...s, vendorWithGstNo: s.vendorName + ' - ' + s.gstTinNo }
                        } else {
                            return { ...s, vendorWithGstNo: s.vendorName }
                        }
                    })
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((v) => selectedValues.indexOf(v.vendorId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getVendorOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countryId, searchVendorCategories]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((v) => selectedValues.indexOf(v.vendorId) >= 0);
        }
        setDefaultProps({ ...defaultProps, disabled, preSelectedValues, dataLoaded: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((v) => selectedValues.indexOf(v.vendorId) >= 0);
        }
        setDefaultProps({ ...defaultProps, nextId, prevId, preSelectedValues });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextId, prevId]);

    useEffect(() => {
        let preSelectedValues = [];
        // console.log('selectedValues',selectedValues);
        if(selectedValues.length > 0){
            if(selectedValues.length > 0){
                preSelectedValues =  defaultProps.options.filter((v) => selectedValues.indexOf(v.vendorId) >= 0);
                const newProps = {...defaultProps, preSelectedValues, dataLoaded:true}
                setDefaultProps(newProps);
            }
        }
        // else{
        //     const newProps = {...defaultProps, preSelectedValues, dataLoaded:true}
        //     setDefaultProps(newProps);
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedValues]);

    return (defaultProps.dataLoaded ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default VendorAutocomplete;